import { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { Link } from 'dibs-elements/exports/Link';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { Header } from 'dibs-elements/exports/Header';

// components
import { viewMore } from '../../pdpMessages';
import { PageLayout } from 'dibs-elements/exports/PageLayout';

// styles
import styles from './PdpRespSimilarItemsContainer.scss';

function PdpRespSimilarItemsContainerComponent(props) {
    const {
        header,
        subtitle,
        subHeader,
        children,
        dataTn,
        gridWrapperClass,
        gridHeaderClass,
        isHorizontal,
        item,
        scrollToRef,
        ...options
    } = props;

    const isNotListedOrSold = !item?.seller?.isAccessible || item?.isSold;

    const wrapperClass = classnames(styles.wrapper, {
        [styles.hasSubtitle]: !!subtitle,
        [styles.isTopContainer]: options.isTopContainer,
    });
    const contentClass = classnames(styles.content, gridWrapperClass, {
        [styles.isHorizontal]: isHorizontal,
    });
    const subtitleClass = classnames(isNotListedOrSold ? styles.subtitleSoldPdp : styles.subtitle, {
        [styles.hasHeader]: !!header,
    });
    const headerClass = classnames(styles.header, { [`${gridHeaderClass}`]: !!gridHeaderClass });

    const pageLayoutProps = {
        setViewportBackground: options.isDark, // to set the default dark viewport background
        // to remove the offets so that the the default layout would be coming from main PDP container
        setOffset: options.isDark,
    };

    return (
        <PageLayout {...pageLayoutProps} dataTn={dataTn}>
            {/* give wrapper tabIndex to allow focus on "view more" scroll to */}
            <div tabIndex={-1} ref={scrollToRef} className={wrapperClass}>
                {/* Header */}
                {header && (
                    <HeadingLevel>
                        {Heading =>
                            item?.isSold ? (
                                <Fragment>
                                    <div className={headerClass}>
                                        <Header
                                            htmlElementType={Heading}
                                            title={header}
                                            dataTn="sold-header"
                                        />
                                    </div>
                                    {!options.hideBar && <div className={styles.soldHeader} />}
                                </Fragment>
                            ) : (
                                <Heading className={headerClass}>{header}</Heading>
                            )
                        }
                    </HeadingLevel>
                )}
                {/* FULL WIDTH OF PAGE */}
                <div className={contentClass} data-tn="pdp-similar-items">
                    {!!subHeader && subHeader}
                    {!!subtitle && (
                        <div className={subtitleClass}>
                            {subtitle}{' '}
                            <Link
                                className={classnames(styles.viewMore, {
                                    [styles.viewMoreSoldPdp]: isNotListedOrSold,
                                })}
                                onClick={options.onClickViewMore}
                                dataTn="view-more-similar-items"
                            >
                                {viewMore}
                            </Link>
                        </div>
                    )}
                    {/* Grid of Items */}
                    {children}
                </div>
            </div>
        </PageLayout>
    );
}

PdpRespSimilarItemsContainerComponent.propTypes = {
    header: PropTypes.node,
    subHeader: PropTypes.node,
    subtitle: PropTypes.node,
    children: PropTypes.node,
    gridWrapperClass: PropTypes.string,
    gridHeaderClass: PropTypes.string,
    dataTn: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
    scrollToRef: PropTypes.object,

    // options
    isDark: PropTypes.bool,
    isHorizontal: PropTypes.bool,
    hideBar: PropTypes.bool,
    onClickViewMore: PropTypes.func,
    isTopContainer: PropTypes.bool,
};

export const PdpRespSimilarItemsContainer = createFragmentContainer(
    PdpRespSimilarItemsContainerComponent,
    {
        item: graphql`
            fragment PdpRespSimilarItemsContainer_item on Item {
                isSold
                seller {
                    isAccessible
                }
            }
        `,
    }
);
